import { create } from 'zustand';
import { useShallow } from 'zustand/shallow';

import { type Responder } from '../lib/respond-with-message';
import { WrapperTheme } from '../types';
import { type PlaydeckState } from './types';

export const usePlaydeckStoreRaw = create<PlaydeckState>()((set) => ({
  progress: 0,
  isPlaydeckOpen: true,
  isTopBarVisible: true,
  hideUI: false,
  loadingEndSended: false,
  theme: WrapperTheme.DEFAULT,
  respond: null,
  gameControlsBackButton: false,
  scoreModal: null,
  circlesScoreModal: null,
  actions: {
    hydrate: (fresh) => set(fresh),
    setProgress: (percent: number) => set(() => ({ progress: percent })),
    setPlaydeckOpen: (open: boolean) => set(() => ({ isPlaydeckOpen: open })),
    setTopBarVisibility: (visible: boolean) => set(() => ({ isTopBarVisible: visible })),
    setHideUI: (hide: boolean) => set(() => ({ hideUI: hide })),
    setResponder: (respond: Responder) => set({ respond }),
    setLoadingEnded: () => set({ loadingEndSended: true }),
    setTheme: () => {},
    setGameControlsBackButton: (value: boolean) => set({ gameControlsBackButton: value }),
  },
}));

export const usePlaydeckState = () =>
  usePlaydeckStoreRaw(
    useShallow((state) => ({
      isPlaydeckOpen: state.isPlaydeckOpen,
      respond: state.respond,
      loadingEndSended: state.loadingEndSended,
      actions: state.actions,
    }))
  );

export const usePlaydeckActions = () => usePlaydeckStoreRaw((state) => state.actions);
export const useProgress = () => usePlaydeckStoreRaw((state) => state.progress);
export const usePlaydeckOpen = () => usePlaydeckStoreRaw((state) => state.isPlaydeckOpen);
export const useHideUI = () => usePlaydeckStoreRaw((state) => state.hideUI);
export const useTopBarVisible = () =>
  usePlaydeckStoreRaw(useShallow((state) => state.isTopBarVisible));

export const useTheme = () => usePlaydeckStoreRaw(useShallow((state) => state.theme));

export const useGameControlsBackButton = () =>
  usePlaydeckStoreRaw((state) => state.gameControlsBackButton);

export const useScoreModal = () => usePlaydeckStoreRaw((state) => state.scoreModal);

export const useCirclesScoreModal = () =>
  usePlaydeckStoreRaw((state) => state.circlesScoreModal);
